import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Card, Button, Modal, Dropdown } from "react-bootstrap";
import GoBack from "../General/GoBack";
import API_URL from "../../localhost/config"; // Importa la variable global
import ModalCompartir from "./ModalCompartir";
import Spinner from "../utils/Spinner";
import Sidebar from "../Sidebar/Sidebar";
import "@fortawesome/fontawesome-free/css/all.css";

//Toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const notifySuccess = (mensaje) => {
  toast.success(mensaje, {
    position: "bottom-right",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

const notifyWanr = (mensaje) => {
  toast.warn(mensaje, {
    position: "bottom-right",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

const FONDO = "fondo";
const LETRA = "letra";

const Equipos = () => {
  //Token
  const [token, setToken] = useState(localStorage.getItem("token"));

  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const [showModal, setShowModal] = useState(false);
  const [showModalCompartirJugadores, setShowModalCompartirJugadores] =
    useState(false);

  const [equipos, setEquipos] = useState([]);
  const [equiposDisp, setEquiposConDisp] = useState([]);
  const { idTorneo } = useParams();
  const [selectedEquipo, setSelectedEquipo] = useState(null);
  const [equiposRestantes, setEquiposRestantes] = useState(null);

  const [prioridades, setPrioridades] = useState([]);

  // Creación equipo
  const [nombreEquipo, setNombreEquipo] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [postEquipo, setPostEquipo] = useState(false);

  // Eliminación equipo
  const [showModalConfirmation, setShowModalConfirmation] = useState(false);
  const [equipoAEliminar, setEquipoAEliminar] = useState(null);

  //Loading
  const [isLoadingEquipos, setIsLoadingEquipos] = useState(true); // Estado para controlar si los datos están cargados
  const [isLoadingPrioridades, setIsLoadingPrioridades] = useState(true); // Estado para controlar si los datos están cargados

  const handleEditarEquipo = async (equipo) => {
    setSelectedEquipo(equipo);
    setShowModal(true);
  };

  const handleEditarCompartir = async (equipo) => {
    setSelectedEquipo(equipo);
    setShowModalCompartirJugadores(true);
  };

  const handleCloseCompartir = () => {
    setSelectedEquipo(null);
    setShowModalCompartirJugadores(false);
  };

  const handleClose = () => {
    setSelectedEquipo(null);
    setShowModal(false);
  };

  useEffect(() => {
    const obtenerEquipos = async () => {
      try {
        setIsLoadingEquipos(true);
        const response = await axios.get(
          `${API_URL}/getTeams?idTorneo=${idTorneo}`,
          headers
        );
        setEquipos(response.data);
      } catch (error) {
        // console.error("Error al obtener equipos:", error.message);
        notifyWanr("Error al obtener los equipos.");
      } finally {
        setIsLoadingEquipos(false);
      }
    };

    obtenerEquipos();
  }, [idTorneo, postEquipo]);

  useEffect(() => {
    // Función para obtener las prioridades
    const obtenerPrioridades = async () => {
      try {
        const response = await axios.get(`${API_URL}/getPrioridades`, headers);
        setPrioridades(response.data);
      } catch (error) {
        // console.error("Error al obtener prioridades:", error.message);
        notifyWanr("Error al obtener prioridades");
      }
    };

    obtenerPrioridades();
  }, [equiposDisp]);

  useEffect(() => {
    setIsLoadingPrioridades(true);
    if (equipos && equipos.length > 0) {
      const promesas = equipos.map(async (equipo) => {
        try {
          const response = await axios.get(
            `${API_URL}/getAvailabilityByTeam?idEquipo=${equipo.id}`,
            headers
          );
          return {
            ...equipo,
            disponibilidad: response.data,
          };
        } catch (error) {
          // console.error(
          //   "Error al obtener disponibilidad del equipo:",
          //   error.message
          // );
          notifyWanr("Error al obtener disponibilidad del equipo");
          return equipo;
        }
      });

      Promise.all(promesas)
        .then((equiposConDisponibilidad) => {
          setEquiposConDisp(equiposConDisponibilidad);
        })
        .catch((error) => {
          // console.error(
          //   "Error al obtener disponibilidad de equipos:",
          //   error.message
          // );
          notifyWanr("Error al obtener disponibilidad de equipos.");
        });
    }
    setIsLoadingPrioridades(false);
  }, [equipos]);

  const handleAgregarEquipo = async () => {
    if (nombreEquipo.trim() === "") {
      setError("El nombre del equipo está vacío.");
      return;
    }

    // Crear equipos
    const equiposTransformados = [
      {
        nombre: nombreEquipo,
        idTorneo: idTorneo,
      },
    ];

    const bodyEquipos = { equipos: equiposTransformados };

    try {
      await axios.post(
        `${API_URL}/equipos?idTorneo=${idTorneo}`,
        bodyEquipos,
        headers
      );

      // setSuccessMessage("Equipo agregado exitosamente.");
      notifySuccess("Equipo agregado exitosamente.");
      setPostEquipo((prevPostEquipo) => !prevPostEquipo);

      setNombreEquipo("");
      setError("");
    } catch (error) {
      setError("Error al agregar el equipo:", error.message);
      notifyWanr("Error al agregar el equipo.");
    }
    setPostEquipo(Date.now());
  };

  const handleEliminarEquipo = async (idEquipo) => {
    setShowModalConfirmation(true);
    setEquipoAEliminar(idEquipo);
  };

  const confirmarEliminacion = async (idEquipo) => {
    setShowModalConfirmation(false);

    try {
      // Realizar la solicitud DELETE a la API para eliminar el equipo
      await axios.delete(`${API_URL}/deleteTeam/${idEquipo}`, headers);
      // Actualizar la lista de equipos después de eliminar el equipo
      const nuevosEquipos = equipos?.filter((equipo) => equipo.id !== idEquipo);
      const nuevosEquiposDispo = equiposDisp?.filter(
        (equipo) => equipo.id !== idEquipo
      );

      setEquipos(nuevosEquipos);
      setEquiposConDisp(nuevosEquiposDispo);
      notifySuccess("Equipo eliminado correctamente.");
    } catch (error) {
      // Puedes utilizar setError para manejar el error en tu aplicación
      setError(error.response?.data.error);
      notifyWanr(
        "Error al eliminar equipo. " +
          "Es posible que comparta jugadores con otro equipo."
        // + error.response?.data.error
      );
    }
  };

  useEffect(() => {
    const equiposRestantes = equiposDisp?.filter(
      (equipo) => equipo?.id !== selectedEquipo?.id
    );
    // Actualizar el estado de equiposRestantes
    setEquiposRestantes(equiposRestantes);
  }, [selectedEquipo, equipos]);

  return (
    <div className="row p-0 g-0">
      <div className="col-sm-auto p-0 g-0 flex-column">
        <Sidebar> </Sidebar>
      </div>
      <div className="col-sm-6 px-5 g-0 mx-auto">
        <div className="section-title mt-5">
          <h3>
            Equipos <span>del torneo</span>
          </h3>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}
        {successMessage && (
          <div className="alert alert-success" style={{ marginTop: "10px" }}>
            {successMessage}
          </div>
        )}

        <div className="row g-0">
          <div className="row g-0">
            <input
              type="text"
              placeholder="Nombre del equipo"
              value={nombreEquipo}
              onChange={(e) => setNombreEquipo(e.target.value)}
              className="form-control"
            />
          </div>
          <div className="row g-0">
            <button className="btn btn-primary" onClick={handleAgregarEquipo}>
              Agregar equipo
            </button>
          </div>
        </div>

        {isLoadingEquipos ? (
          <Spinner />
        ) : (
          <div className="mt-3 g-0 row align-items-center">
            {equiposDisp.map((equipo, index) => (
              <div className="col-sm-6" key={equipo.id}>
                <div
                  className="row g-0 align-items-center py-3"
                  style={{ borderBottom: "1px solid #ccc", fontSize: "20px" }}
                >
                  <div className="col-6">
                    <h5>{equipo.Nombre}</h5>
                  </div>
                  <div className="col-6 d-flex align-items-center justify-content-center">
                    <i
                      className="fas fa-trash me-2 text-danger px-2"
                      onClick={() => handleEliminarEquipo(equipo.id)}
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Eliminar equipo"
                      style={{ cursor: "pointer" }}
                    ></i>
                    <i
                      className="fas fa-edit me-2 text-primary px-2"
                      onClick={() => handleEditarEquipo(equipo)}
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Editar disponibilidad"
                      style={{ cursor: "pointer" }}
                    ></i>
                    <i
                      className="fas fa-link text-primary px-2"
                      onClick={() => handleEditarCompartir(equipo)}
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Comparten jugadores"
                      style={{ cursor: "pointer" }}
                    ></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {/* MODALES */}
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedEquipo ? selectedEquipo.Nombre : ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedEquipo ? (
            <div>
              <table style={{ margin: 0 }}>
                {selectedEquipo.disponibilidad.map((disponibilidadItem) => (
                  <PrioridadDropdown
                    key={disponibilidadItem.idEquipo}
                    disponibilidadItem={disponibilidadItem}
                    prioridades={prioridades}
                  />
                ))}
              </table>
            </div>
          ) : (
            <p>Cargando disponibilidad...</p>
          )}
        </Modal.Body>
      </Modal>

      <ModalCompartir
        mostrarModal={showModalCompartirJugadores}
        cerrarModal={handleCloseCompartir}
        equipo={selectedEquipo}
        equipos={equiposRestantes}
      />
      <Modal
        show={showModalConfirmation}
        onHide={() => setShowModalConfirmation(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Advertencia</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Al eliminar este equipo, perderás la configuración que agregaste para
          sus turnos. ¿Estás seguro de que deseas eliminarlo?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowModalConfirmation(false)}
          >
            Cancelar
          </Button>
          <Button
            variant="danger"
            onClick={() => confirmarEliminacion(equipoAEliminar)}
          >
            Eliminar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

function PrioridadDropdown({ disponibilidadItem, prioridades }) {
  //Token
  const [token, setToken] = useState(localStorage.getItem("token"));

  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // Crea un estado local para cada disponibilidadItem
  const [localSelectedPrioridad, setLocalSelectedPrioridad] = useState(null);

  const [isLoadingPrioridades, setIsLoadingPrioridades] = useState(true); // Estado para controlar si los datos están cargados

  useEffect(() => {
    let idEquipo = disponibilidadItem.idEquipo;
    let idTurno = disponibilidadItem.idTurno;
    setIsLoadingPrioridades(true);
    const obtenerPrioridadDesdeBD = async () => {
      try {
        const prioridadDesdeBD = await axios.get(
          `${API_URL}/getPriorityByTeamAndTurn?idEquipo=${idEquipo}&&idTurno=${idTurno}`,
          headers
        );
        setLocalSelectedPrioridad(prioridadDesdeBD.data[0]);
      } catch (error) {
        console.error("Error al obtener prioridades:", error.message);
        notifyWanr("Error al obtener prioridades");
      } finally {
        setIsLoadingPrioridades(false);
      }
    };

    obtenerPrioridadDesdeBD();
  }, [disponibilidadItem]); // Agregar ambas propiedades al array de dependencias

  useEffect(() => {
    // Puedes realizar acciones cuando localSelectedPrioridad cambie aquí, si es necesario
    // console.log(
    //   "Local Selected Prioridad actualizada:",
    //   localSelectedPrioridad
    // );
  }, [localSelectedPrioridad]);

  return (
    <div>
      {isLoadingPrioridades ? (
        <Spinner />
      ) : (
        <tr style={{ listStyle: "none", margin: 0 }}>
          <td style={{ width: "45%" }}>
            <Dropdown
              onSelect={(eventKey) => {
                handlePrioridadSelect(
                  prioridades,
                  eventKey,
                  disponibilidadItem,
                  setLocalSelectedPrioridad,
                  headers
                );
              }}
            >
              <Dropdown.Toggle
                variant="success"
                id="dropdown-basic"
                style={{
                  backgroundColor: obtenerColorDePrioridad(
                    localSelectedPrioridad?.id,
                    FONDO
                  ),
                  color: obtenerColorDePrioridad(
                    localSelectedPrioridad?.id,
                    LETRA
                  ),
                }}
              >
                {localSelectedPrioridad?.Descripcion}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {prioridades.map((prioridad) => (
                  <Dropdown.Item
                    key={prioridad.id}
                    eventKey={prioridad.id}
                    style={{
                      backgroundColor: obtenerColorDePrioridad(prioridad.id),
                    }}
                  >
                    {prioridad.Descripcion}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </td>
          <td style={{ width: "55%" }}>
            <span style={{ display: "inline-block", marginLeft: "10px" }}>
              {`${disponibilidadItem.Dia} a las ${disponibilidadItem.Horario} en ${disponibilidadItem.Nombre}`}
            </span>
          </td>
        </tr>
      )}
    </div>
  );
}

async function handlePrioridadSelect(
  prioridades,
  eventKey,
  disponibilidadItem,
  setLocalSelectedPrioridad,
  headers
) {
  const selectedPrioridadObject = prioridades.find(
    (prioridad) => prioridad.id === parseInt(eventKey)
  );

  // Verificar si se encontró la prioridad correspondiente
  if (selectedPrioridadObject) {
    setLocalSelectedPrioridad(selectedPrioridadObject);
  } else {
    console.error(
      "No se encontró la prioridad correspondiente al id:",
      eventKey
    );
  }

  const url = `${API_URL}/updateAvailability`;

  const data = {
    idEquipo: disponibilidadItem.idEquipo,
    prioridad: parseInt(eventKey),
    idTurno: disponibilidadItem.idTurno,
  };

  try {
    await axios
      .put(url, data, headers)
      .then(() => notifySuccess("Modificado correctamente"));
  } catch (error) {
    console.error(
      "Error al actualizar disponibilidad del equipo:",
      error.message
    );
  }
}

function obtenerColorDePrioridad(idPrioridad, obj) {
  if (obj === FONDO) {
    switch (idPrioridad) {
      case 1:
        return "green";
      case 2:
        return "yellow";
      case 3:
        return "orange";
      case 4:
        return "red";
      default:
        return "white";
    }
  } else if (obj === LETRA) {
    switch (idPrioridad) {
      case 1:
        return "white";
      case 4:
        return "white";
      default:
        return "black";
    }
  }
}

export default Equipos;
